import DispatcherBase from './dispatcher.base';

class ActionDispatcher extends DispatcherBase {
  constructor() {
    super({ name: 'action-dispatcher' });
  }
}

export default new ActionDispatcher();
